package org.example.project.planner

import org.example.project.client.api.PlannerApiClient
import org.example.project.client.api.addFavoriteWithSession
import org.example.project.client.api.createEventWithSession
import org.example.project.client.api.deleteEventWithSession
import org.example.project.client.api.getEventWithSession
import org.example.project.client.api.getFavoritesWithSession
import org.example.project.client.api.listEventsWithSession
import org.example.project.client.api.removeFavoriteWithSession
import org.example.project.client.api.updateEventWithSession
import org.example.project.client.api.ActivityApiClient
import org.example.project.client.model.ActivityFilters
import org.example.project.client.model.ActivityResponse
import org.example.project.client.model.CreateEventRequest
import org.example.project.client.model.EventResponse
import org.example.project.client.model.FavoritesResponse
import org.example.project.client.model.UpdateEventRequest
import org.example.project.client.session.SessionRepository

interface PlannerRepository {
    suspend fun listEvents(): List<EventResponse>
    suspend fun getEvent(id: String): EventResponse
    suspend fun createEvent(request: CreateEventRequest): EventResponse
    suspend fun updateEvent(id: String, request: UpdateEventRequest): EventResponse
    suspend fun deleteEvent(id: String, expectedVersion: Long)
    suspend fun getFavorites(): FavoritesResponse
    suspend fun addFavorite(activityId: String)
    suspend fun removeFavorite(activityId: String)
    suspend fun listCatalogActivities(search: String? = null): List<ActivityResponse> = emptyList()
}

class DefaultPlannerRepository(
    private val plannerApiClient: PlannerApiClient,
    private val sessionRepository: SessionRepository,
    private val activityApiClient: ActivityApiClient? = null
) : PlannerRepository {

    override suspend fun listCatalogActivities(search: String?): List<ActivityResponse> {
        return try {
            activityApiClient?.listActivities(ActivityFilters(search = search))?.items ?: emptyList()
        } catch (_: Exception) {
            emptyList()
        }
    }


    override suspend fun listEvents(): List<EventResponse> {
        return plannerApiClient.listEventsWithSession(sessionRepository)
    }

    override suspend fun getEvent(id: String): EventResponse {
        return plannerApiClient.getEventWithSession(id, sessionRepository)
    }

    override suspend fun createEvent(request: CreateEventRequest): EventResponse {
        return plannerApiClient.createEventWithSession(request, sessionRepository)
    }

    override suspend fun updateEvent(id: String, request: UpdateEventRequest): EventResponse {
        return plannerApiClient.updateEventWithSession(id, request, sessionRepository)
    }

    override suspend fun deleteEvent(id: String, expectedVersion: Long) {
        plannerApiClient.deleteEventWithSession(id, expectedVersion, sessionRepository)
    }

    override suspend fun getFavorites(): FavoritesResponse {
        return plannerApiClient.getFavoritesWithSession(sessionRepository)
    }

    override suspend fun addFavorite(activityId: String) {
        plannerApiClient.addFavoriteWithSession(activityId, sessionRepository)
    }

    override suspend fun removeFavorite(activityId: String) {
        plannerApiClient.removeFavoriteWithSession(activityId, sessionRepository)
    }
}
